// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"52d635fb","317":"8d457cec"}[chunkId] + ".chunk.js";
};